(function ($) {
 
        if ($(".image-compare").length) {
            $(".image-compare").each(function () {
                let isDragging = false;
                let container = $(this);
                let handle = container.find(".handle");
                let afterImage = container.find(".after-image");

                function moveHandle(e) {
                    if (!isDragging) return;

                    let offsetX = e.pageX || e.originalEvent.touches[0].pageX;
                    let relativeX = offsetX - container.offset().left;
                    let width = container.width();

                    if (relativeX >= 0 && relativeX <= width) {
                        let percentage = (relativeX / width) * 100;
                        afterImage.css("width", percentage + "%");
                        handle.css("left", percentage + "%");
                    }
                }

                handle.on("mousedown touchstart", function () {
                    isDragging = true;
                });

                $(document).on("mousemove touchmove", function (e) {
                    moveHandle(e);
                });

                $(document).on("mouseup touchend", function () {
                    isDragging = false;
                });
            });

        }


        let slide = $(".p-slide-rd-nav")
        let totalSlide = slide.length
        let currentSlide = 1
        let slideType = '';
        let slideElem = ''
        let isVideo = false
        let videoElem = '';
        let slideInterval;
        let isHovered = false;
  
        totalSlide && startSlide();

        function handleInteractionStart() {
            isHovered = true;
            stopSlide();
        }

        function handleInteractionEnd() {
            isHovered = false;
            !videoElem && startSlide();
            // setTimeout(function () {
            //     if (!isHovered) {
            //         startSlide();
            //     }
            // }, 5000);
        }

        $(".p-slide-wrap").on("mouseenter touchstart", handleInteractionStart).on("mouseleave touchend", handleInteractionEnd);

        function startSlide() {
            slideInterval = setInterval(function () {
                if (totalSlide <= 1) {
                    return
                }
                slide.eq(currentSlide - 1).prop('checked', false)
                if (currentSlide == totalSlide) {
                    currentSlide = 1
                } else {
                    currentSlide += 1
                }
              
                slideType = slide.eq(currentSlide - 1).attr('data-type')
                slideElem = slide.eq(currentSlide - 1).attr('data-ref')                
                slide.eq(currentSlide - 1).prop('checked', true)        
                   
                if(slideType == 'video'){
                  stopSlide();
                  videoElem = null;
                  videoElem = $(`.${slideElem}`).find('video')[0]; 
                  if (videoElem) {                      
                      videoElem.play().catch(err => console.error('Playback failed:', err));   
                      $(videoElem).off('ended').on('ended', function () {  
                          videoElem.pause();     
                          videoElem.currentTime = 0;
                          videoElem = null;                          
                          !isHovered && startSlide();                        
                      });
                  }   
                }
            }, 5000)
        }

        $('.p-slide-rd-nav').click(function() {  
              let currentIndex = $('input[name="p_slide_rd_nav"]').index(this);
              let currentDataType = $(this).attr('data-type');              
              currentSlide = currentIndex+1   
              stopSlide();
              if(slideType == 'video' && !!videoElem){
                videoElem.pause();     
                videoElem.currentTime = 0;
                videoElem = null;
              }
              if(currentDataType == 'video'){
                  slideType = currentDataType;
                  slideElem = $(this).attr('data-ref') 
                  videoElem = $(`.${slideElem}`).find('video')[0]; 
                  if (videoElem) {                     
                      videoElem.play().catch(err => console.error('Playback failed:', err));   
                      $(videoElem).off('ended').on('ended', function () { 
                          videoElem.pause();     
                          videoElem.currentTime = 0;
                          videoElem = null;    
                          !isHovered && startSlide();                        
                      });
                  }   
              }else if(!isHovered){
                setTimeout(function () {
                    startSlide();
                }, 5000);
              }
        })

        // $(".p-slide-wrap").on('mouseenter touchstart', function () {
        //     stopSlide()
        // })

        // $(".p-slide-wrap").on('mouseleave touchend', function () {
        //     if(!videoElem){
        //       startSlide()
        //     }            
        // })

        // $('.p-slide-rd-nav').click(function() {
        //     if ($(this).is(':checked'){
        //         currentSlide = $(this).index()+1                
        //         if(videoElem){
        //            videoElem.pause();
        //            videoElem.currentTime = 0;
        //         }

        //         let slideType = $(this).prop('data-type')
        //         slideElem = $(this).prop('data-ref') 

        //         if(slideType == 'video'){
        //           stopSlide();
        //           videoElem = $(`.${slideElem}`).find('video')[0]; 
        //           if (videoElem) {
        //               videoElem.play().catch(err => console.error('Playback failed:', err));   
        //               $(videoElem).off('ended').on('ended', function () {                       
        //                   videoElem = null;
        //                   startSlide();
        //               });
        //           }   
        //         }               
        //     }
        // });

        function stopSlide() {
          clearInterval(slideInterval)
        }    
    
})(jQuery);